import styled, { css } from 'styled-components';
import { colors } from '../../../theme/styled';
import { text } from '../../../theme/typography';
import downIcon from '../../../images/arrow-expand-down.svg';
import { Link as LinkComponent } from '../../link/link.component';

export const CategoryLink = styled.div`
  position: relative;
  height: 60px;
  width: 100%;
  ${text};
  text-align: left;
  padding-left: 24px;
  padding-right: 24px;
  background-color: ${colors.charcoalGrey};
  color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MainLink = styled(LinkComponent)`
  flex-grow: 1;
  height: 60px;
  line-height: 60px;
`;

export const Toggle = styled.div`
  display: inline-block;
  width: 44px;
  height: 44px;
  background-image: url(${downIcon});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  transition: transform .25s ease-in-out;
  
  ${props => props.isOpen && css`
    transform: rotate(180deg);
  `}
  
  &:focus {
    outline-offset: -2px;
  }
`;

export const Links = styled.ul`
  position: relative;
  list-style: none;
  margin: 0;
  padding: 8px 24px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: #384654;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 10px;
    background-color: #384654;
    width: 100%;
    pointer-events: none;
  }
`;
export const LinkItem = styled.li`
  position: relative;
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  padding-bottom: 8px;
  padding-top: 8px;
  text-align: left;
  flex-grow: 1;
  color: ${colors.white};
  padding-right: 5px;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    height: 1px;
    width: 100%;
    left: 0;
    opacity: .1;
    background-color: ${colors.white};
  }
`;
export const Link = styled(LinkComponent)``;
